import { RewardCardTabSwitcher } from "components/molecules/RewardCardTabSwitcher";
import { useBricksPreloadedProps } from "hooks/useBrickStaticProps";
import React from "react";
import { types } from "react-bricks/frontend";
import { backgroundColorProp } from "../utils/backgroundColor";
import TextHeading from "../common/TextHeading";
import TextBlock from "../common/TextBlock";

interface RewardsListProps {
  title: types.TextValue;
  content: types.TextValue;
  backgroundColor: types.IColor;
}

const RewardsList: types.Brick<RewardsListProps> = ({ backgroundColor }) => {
  const { rewardProps } = useBricksPreloadedProps();
  const title = <TextHeading propName="title" />;
  const content = <TextBlock propName="content" />;
  return (
    <div>
      <RewardCardTabSwitcher
        backgroundColor={backgroundColor?.color}
        title={title}
        content={content}
        rewards={rewardProps?.regionalRewards}
      />
    </div>
  );
};

RewardsList.schema = {
  // Unique brick name
  name: "rewards-list",
  label: "RewardsList",
  previewImageUrl: "/static/bricks/rewards-list.png",
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    title: "Our member rewards & benefits",
    content:
      "We’re always working to bring your people the best in rewards and discounts – and right now, that includes:",
  }),

  // Sidebar Edit controls for props
  sideEditProps: [backgroundColorProp],
};

export default RewardsList;
